import { ITicketAvgResponse } from "../../models/Tickets/Ticket";

interface TicketAvgResponseTableProps {
  avgResponse?: ITicketAvgResponse;
}

/** Hours as the largest sensible unit: 45m, 6h 30m, 2d 17h. */
export function formatHours(hours?: number) {
  if (hours === undefined || hours === null) return "—";
  if (hours < 1) return `${Math.round(hours * 60)}m`;

  if (hours < 24) {
    const wholeHours = Math.floor(hours);
    const minutes = Math.round((hours - wholeHours) * 60);
    return minutes === 0 ? `${wholeHours}h` : `${wholeHours}h ${minutes}m`;
  }

  const days = Math.floor(hours / 24);
  const remainingHours = Math.round(hours % 24);
  return remainingHours === 0 ? `${days}d` : `${days}d ${remainingHours}h`;
}

export default function TicketAvgResponseTable({
  avgResponse,
}: TicketAvgResponseTableProps) {
  if (!avgResponse) return null;

  const rows = [
    {
      label: "First",
      today: avgResponse.firstToday,
      week: avgResponse.firstThisWeek,
      all: avgResponse.firstAll,
    },
    {
      label: "Resolve",
      today: avgResponse.resolveToday,
      week: avgResponse.resolveThisWeek,
      all: avgResponse.resolveAll,
    },
  ];

  const headerClasses =
    "px-3 py-2 text-right text-xs font-semibold text-gray-600";
  const cellClasses = "px-3 py-1.5 text-right text-sm text-slate-800";

  return (
    <div>
      <p className="mb-1 text-xs font-semibold uppercase tracking-wide text-gray-500">
        Avg. Response
      </p>
      <div className="inline-block overflow-hidden rounded-md border border-orange-200">
        <table className="min-w-[19rem] divide-y divide-orange-100">
          <thead className="bg-orange-50">
            <tr>
              <th className="px-3 py-2 text-left text-xs font-semibold text-gray-600" />
              <th className={headerClasses}>Today</th>
              <th className={headerClasses}>Week</th>
              <th className={headerClasses}>All</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-orange-100 bg-white">
            {rows.map((row) => (
              <tr key={row.label}>
                <td className="px-3 py-1.5 text-sm font-medium text-slate-800">
                  {row.label}
                </td>
                <td className={cellClasses}>{formatHours(row.today)}</td>
                <td className={cellClasses}>{formatHours(row.week)}</td>
                <td className={cellClasses}>{formatHours(row.all)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
